"use client";
import {
  usePopoverContext
} from "./chunk-SQ3I4X62.mjs";

// src/popover-content.tsx
import { useMemo, useCallback } from "react";
import { forwardRef } from "@nextui-org/system";
import { DismissButton } from "@react-aria/overlays";
import { TRANSITION_VARIANTS } from "@nextui-org/framer-utils";
import { m, domAnimation, LazyMotion } from "framer-motion";
import { RemoveScroll } from "react-remove-scroll";
import { getTransformOrigins } from "@nextui-org/aria-utils";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var PopoverContent = forwardRef((props, _) => {
  const { as, children, className, ...otherProps } = props;
  const {
    Component: OverlayComponent,
    isOpen,
    placement,
    backdrop,
    motionProps,
    titleProps,
    disableAnimation,
    shouldBlockScroll,
    getPopoverProps,
    getDialogProps,
    getBackdropProps,
    getContentProps,
    isNonModal,
    onClose
  } = usePopoverContext();
  const dialogProps = getDialogProps(otherProps);
  delete dialogProps.role;
  const Component = as || OverlayComponent || "div";
  const content = /* @__PURE__ */ jsxs(Fragment, { children: [
    !isNonModal && /* @__PURE__ */ jsx(DismissButton, { onDismiss: onClose }),
    /* @__PURE__ */ jsx(Component, { ...dialogProps, children: /* @__PURE__ */ jsx("div", { ...getContentProps({ className }), children: typeof children === "function" ? children(titleProps) : children }) }),
    /* @__PURE__ */ jsx(DismissButton, { onDismiss: onClose })
  ] });
  const backdropContent = useMemo(() => {
    if (backdrop === "transparent") {
      return null;
    }
    if (disableAnimation) {
      return /* @__PURE__ */ jsx("div", { ...getBackdropProps() });
    }
    return /* @__PURE__ */ jsx(LazyMotion, { features: domAnimation, children: /* @__PURE__ */ jsx(
      m.div,
      {
        animate: "enter",
        exit: "exit",
        initial: "exit",
        variants: TRANSITION_VARIANTS.fade,
        ...getBackdropProps()
      }
    ) });
  }, [backdrop, disableAnimation, getBackdropProps]);
  const RemoveScrollWrapper = useCallback(
    ({ children: children2 }) => {
      return /* @__PURE__ */ jsx(RemoveScroll, { enabled: shouldBlockScroll && isOpen, removeScrollBar: false, children: children2 });
    },
    [shouldBlockScroll, isOpen]
  );
  const contents = disableAnimation ? /* @__PURE__ */ jsx(RemoveScrollWrapper, { children: content }) : /* @__PURE__ */ jsx(LazyMotion, { features: domAnimation, children: /* @__PURE__ */ jsx(
    m.div,
    {
      animate: "enter",
      exit: "exit",
      initial: "initial",
      style: {
        ...getTransformOrigins(placement === "center" ? "top" : placement)
      },
      variants: TRANSITION_VARIANTS.scaleSpringOpacity,
      ...motionProps,
      children: /* @__PURE__ */ jsx(RemoveScrollWrapper, { children: content })
    }
  ) });
  return /* @__PURE__ */ jsxs("div", { ...getPopoverProps(), children: [
    backdropContent,
    contents
  ] });
});
PopoverContent.displayName = "NextUI.PopoverContent";
var popover_content_default = PopoverContent;

export {
  popover_content_default
};
